'use client';

import {useEffect, useState} from 'react';
import {usePathname, useSearchParams} from 'next/navigation';
import {isBrowser} from '@/lib/utils/page.utils';

export const useLocation = () => {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const [hash, setHash] = useState('');

	useEffect(() => {
		// Only run on the client side
		if (isBrowser()) {
			setHash(window.location.hash);

			const handleHashChange = () => {
				setHash(window.location.hash);
			};

			window.addEventListener('hashchange', handleHashChange);

			return () => {
				window.removeEventListener('hashchange', handleHashChange);
			};
		}
	}, []);

	const search = searchParams.toString();
	const searchStr = search?.length ? `?${search}` : '';
	const url = new URL(`${process.env.NEXT_PUBLIC_EPIC_SERVER_URL}${pathname}${searchStr}${hash}`);

	return {
		url,
		pathname,
		searchParams,
		searchStr,
		hash
	};
};
